import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "bank-dialog" };
const _hoisted_2 = { class: "row justify-end" };
const _hoisted_3 = { class: "q-pa-md" };
const _hoisted_4 = { class: "row items-center q-gutter-x-lg" };
const _hoisted_5 = { class: "bank-list" };
const _hoisted_6 = { class: "column items-center justify-center" };
const _hoisted_7 = ["onClick"];
const _hoisted_8 = { class: "q-pa-sm" };
const _hoisted_9 = { key: 0 };
const _hoisted_10 = {
    key: 0,
    class: "empty-message"
};
const _hoisted_11 = {
    key: 1,
    class: "empty-message"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_q_btn = _resolveComponent("q-btn");
    const _component_q_input = _resolveComponent("q-input");
    const _component_q_spinner = _resolveComponent("q-spinner");
    const _component_q_inner_loading = _resolveComponent("q-inner-loading");
    const _component_q_separator = _resolveComponent("q-separator");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_q_btn, {
                label: "X",
                flat: "",
                onClick: _ctx.closeDialog
            }, null, 8, ["onClick"])
        ]),
        _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_q_input, {
                    modelValue: _ctx.searchBank,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.searchBank) = $event)),
                    style: { "width": "150px" },
                    placeholder: "金融機関名",
                    dense: "",
                    disable: _ctx.isLoading
                }, null, 8, ["modelValue", "disable"]),
                _cache[1] || (_cache[1] = _createElementVNode("span", null, "銀行", -1)),
                _createVNode(_component_q_btn, {
                    label: "検索",
                    color: "green",
                    disable: _ctx.isLoading,
                    onClick: _ctx.onSearch
                }, null, 8, ["disable", "onClick"])
            ])
        ]),
        _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_q_inner_loading, { showing: _ctx.isLoading }, {
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_6, [
                        _createVNode(_component_q_spinner, {
                            size: "100px",
                            color: "green"
                        }),
                        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "q-mt-md text-subtitle1" }, " 処理中... ", -1))
                    ])
                ]),
                _: 1
            }, 8, ["showing"]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayBankList, (bank) => {
                return (_openBlock(), _createElementBlock("div", {
                    key: bank.code,
                    class: "bank-row",
                    onClick: ($event) => (_ctx.onRowClick(bank))
                }, [
                    _createElementVNode("div", _hoisted_8, _toDisplayString(bank.name), 1),
                    _createVNode(_component_q_separator)
                ], 8, _hoisted_7));
            }), 128)),
            (!_ctx.isLoading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    (_ctx.displayBankList.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, " 上記以外の金融機関は検索してください "))
                        : (_openBlock(), _createElementBlock("div", _hoisted_11, " データが見つかりませんでした。 "))
                ]))
                : _createCommentVNode("", true)
        ])
    ]));
}
